module.exports = __webpack_public_path__ + "static/Checkliste_Homeoffice-9ef7329da6425bb010f6bc2649809002.pdf";